import _ from 'lodash'
import { loadAll, loadAllByType } from '@/api/config'
import { CONFIG_COMMITS as COMMITS, CONFIG_DISPATCHS as DISPATCHS, CONFIG_NAMESPACE } from '@/store/contracts'
const { isObject } = _
const state = {}
const loadedOfType = {}

const mutations = {
    [COMMITS.PUT]: function (state, { category, config }) {
        let cConfig = state[category];
        if (cConfig) {
            Object.assign(state[category], config)
        } else {
            state[category] = config
        }

    }
}
const actions = {
    [DISPATCHS.LOAD]: async function ({ commit, state }, categoryandKey) {

        let category, key;
        let isObjectArg = false
        if (isObject(categoryandKey)) {
            category = categoryandKey.category
            key = categoryandKey.key
            isObjectArg = true
        } else {
            category = categoryandKey
        }
        if (!state[category]) {
            const config = loadConfig(category).then(r => r.data);
            if (config) {
                commit(COMMITS.PUT, { category, config });
            }

        }
        let val = state[category]
        if (val) {
            if (val instanceof Promise) {
                val = await val
                commit(COMMITS.PUT, { category, val });
            }
            if (val) {
                if (isObjectArg) {
                    if (!key) {
                        const keys = Object.keys(val)
                        if (keys && keys.length) {
                            key = keys[0]
                        }
                    }
                    if (key) {
                        return val[key];
                    }
                } else {
                    return val
                }
            }


        }



    },
    [DISPATCHS.LOAD_BY_TYPE]: async function ({ commit, state }, type) {
        if (!loadedOfType[type]) {
            const configs = await loadAllByType(type).then(r => r.data);
            if (configs) {
                for (const category in configs) {
                    if (Object.hasOwnProperty.call(configs, category)) {
                        const config = configs[category];
                        if (!state[category]) {
                            commit(COMMITS.PUT, { category, config });
                        }
                    }
                }
                loadedOfType[type] = configs
            }
        }
        return loadedOfType[type]

    }
}
const key_prefix = `store/config/`
function loadCacheConfig(category){
    const key = `${key_prefix}${category}`
    const str = localStorage.getItem(key)
    if(str){
        return JSON.parse(str)
    }
}
async function loadConfig(category) {
    
    //从缓存找，如果存在，则根据哈希码检查服务端数据是否有变化，没有变化则取缓存的
    const options = {}
    let cacheObj
    try {
        if (localStorage) {
            cacheObj = loadCacheConfig(category)
            if (cacheObj && cacheObj.hash) {
                options.hash = cacheObj.hash
            } else {
                options.hash = 1
            }
        }
    } catch (ex) {
        console.error(ex)
    }
    const resp = await loadAll(category, options)
    
    const key = `store/config/${category}`
    if (resp.hash && options.hash && resp.hash === options.hash && !resp.data) {
        if(cacheObj){
            resp.data = cacheObj.value
        }        
    } else if (resp.hash && localStorage) {
        try {
            localStorage.setItem(key,
                JSON.stringify(
                    {
                        hash: resp.hash,
                        value: resp.data
                    }
                ))
        } catch (ex) {
            console.error(ex)
        }
    }

    return resp
}




// class ConfigController{
//     constructor(store){
//         this._store = store
//     }
//     async load(typeName){
//         return await this._store.dispatch(
//             CONFIG_NAMESPACE + '/' + DISPATCHS.LOAD,
//             typeName
//         )
//     }
// }

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
// export {ConfigController}